module.exports = __webpack_public_path__ + "img/history_btn.4b8e5191.png";